/**
 * Create Ominitech App context for custom hook
 */
import { createContext } from 'react'

const OmnitechApp = createContext({
  api: {}
})

export default OmnitechApp
